module.exports = __webpack_public_path__ + "img/enhancer3.eb7065c3.webp";